import { render, staticRenderFns, recyclableRender, components } from "./custom-tabbar.vue?vue&type=template&id=48eece8c&scoped=true&"
var renderjs
import script from "./custom-tabbar.vue?vue&type=script&lang=js&"
export * from "./custom-tabbar.vue?vue&type=script&lang=js&"
import style0 from "./custom-tabbar.vue?vue&type=style&index=0&id=48eece8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eece8c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/custom-tabbar/custom-tabbar.vue"
export default component.exports